module.exports = __webpack_public_path__ + "img/sv1.060a4681.svg";